import {alpha, Link, Stack} from "@mui/material";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import ReactGA from "react-ga4";
import {useTheme} from "@mui/material/styles";
import useSocialMedia from "../../../hooks/useSocialMedia";

const SocialMedia = () => {
    const theme = useTheme()
    const {socialMedia} = useSocialMedia()

    const handleOnSocialMediaClick = (label: string) => {
        ReactGA.event({
            category: 'Social Links',
            action: 'social_link_click',
            label,
        })
    }
    return (
        <Stack spacing={3} sx={{position: "absolute", left: 5, top: 130}}>
            {socialMedia.map(({label, link, icon}) => (
                <Box key={label}
                     textAlign="center"
                     sx={{
                         transform: "rotate(-90deg)",
                         cursor: "pointer",
                         p: 1,
                         borderRadius: "4px",
                         textDecoration: 'none',
                         transition: "background-color, .2s",
                         "&:hover": {
                             backgroundColor: alpha(theme.palette.primary.main, .1),
                             boxShadow: 3
                         }
                     }} onClick={() => handleOnSocialMediaClick(label)} component={Link} href={link} target="_blank"
                     rel="noopener noreferrer">
                    {icon}
                    <Typography variant="body2" color="primary">
                        {label}
                    </Typography>
                </Box>
            ))}
        </Stack>
    )
}

export default SocialMedia
